import { useState } from "react";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setMessage(res.data.message || "Reset link sent to your email.");
    } catch (err) {
      setMessage(err.response?.data?.message || "Error sending reset link!");
    }
  };

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row justify-center">
          <div className="col-xl-6">
            <div className="border border-gray-100 rounded-16 px-24 py-40">
              <h6 className="text-xl mb-32">Forgot Password</h6>
              <form onSubmit={handleForgotPassword}>
                <div className="mb-24">
                  <label className="text-neutral-900 text-lg mb-8 fw-medium">
                    Enter your registered email
                  </label>
                  <input
                    type="email"
                    className="common-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-main py-18 px-40">
                  Send Reset Link
                </button>
              </form>

              {message && (
                <p className="mt-24 text-center text-sm text-gray-600">{message}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
